import axios from 'axios';
import React, { useContext, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import Input from '../components/forms/Input';
import { initializeApp } from "firebase/app";
import {setToLocalStorage} from '../components/helper/auth'
import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
    sendEmailVerification,
} from "firebase/auth";
import {
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc,
} from "firebase/firestore";
import { firebaseConfig } from "../firebaseConfig"
import { AuthContext } from '../context/auth';
import { useNavigate ,Link} from 'react-router-dom';
import Button from '../components/forms/Button';

export default function Register() {
    const [authc, setAuth] = useContext(AuthContext);
    console.log(authc)
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [loading, setLoading] = useState();
    const [comfirmPassword, setComfirmPassword] = useState("");
    const navigate=useNavigate();
    const app = initializeApp(firebaseConfig);
    const auth = getAuth();
     

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            if (password !== comfirmPassword) {
                toast.error("Password do not match");
                setLoading(false)
                return;
            }
            setLoading(true)
          createUserWithEmailAndPassword(auth, email, password).then(async (userCredential) => {
                toast.success("Registration successful Confirm Email")
                sendEmailVerification(userCredential.user)
                setAuth(userCredential.user)
                setToLocalStorage("auth",userCredential.user)
                
                setTimeout(()=>{
                    navigate('/dashboard')
                },2000)
                
            }).catch((error) => {
                toast.error("Registration Unsuccessful ")
                setLoading(false)
                const errorCode = error.code; 
                const errorMessage = error.message;
            });
        } catch (error) {
            setLoading(false)
            console.log(error);
        }
    }
    return (

        <div style={{ margin: "100px" }} className='d-flex justify-content-center align-items-center vh-100' >
            <Toaster />
            <div className='container'>
                <div className='row'>
                    <div className='col-md-6 offset-md-3'>
                        <h1 className='fw-bold mb-3'>Register</h1>

                        <form>
                            <Input value={email} setValue={setEmail} label="Email" type="email" />
                            <Input value={password} setValue={setPassword} label="Password" type="password" />
                            <Input value={name} setValue={setName} label="Name" type="name" />
                            <Input value={comfirmPassword} setValue={setComfirmPassword} label="Confirm Password" type="password" />
                            <Button handleSubmit={handleSubmit} 
                                    className={"btn btn-primary" }
                                    type={"submit"}
                                    text={"Submit"}
                                    name={name}
                                    email={email}
                                    password={password} 
                                    loading={loading}/>

                        </form>
                        <p className='mt-3'>Already registered <Link to={"/login"}>Login</Link> </p> 
                    </div>

                </div>

            </div>

            <pre>                       {JSON.stringify({ email, password, name, comfirmPassword }, null, 4)}</pre>

        </div>
    )

}
